/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  string, func, number
} from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { Favorite } from '@thd-olt-component-react/save-to-favorites';
import { Price } from '@thd-olt-component-react/price';
import { SuperSkuMiniSwatches } from '@thd-olt-component-react/super-sku';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import {
  ProductPod,
  ProductATC,
  ProductRating,
  ProductSponsored,
  ProductImage,
  ProductIdentifier,
  PodFooter,
  ProductBadge,
  PodSpacer, PodSection, PodSticker
} from '@thd-olt-component-react/product-pod';

export const IntegratedBrandBathPod = ({
  itemId,
  storeId,
  parent,
  position,
  onClick
}) => {
  return (
    <ProductPod
      itemId={itemId}
      storeId={storeId}
      padding="sui-p-2"
      hasSSKU
      analyticsData={{ parent, position }}
      render={(pod) => (
        <>
          <PodSticker noPadding position="top-left">
            <ProductBadge itemId={pod.itemId} storeId={storeId} />
            <ProductSponsored itemId={pod.itemId} position={position} />
          </PodSticker>
          <PodSticker position="top-right">
            <PodSpacer padding={['RIGHT']}>
              <Favorite itemId={pod.itemId} showCount showCircle />
            </PodSpacer>
          </PodSticker>
          <ProductImage
            itemId={pod.itemId}
            showSecondaryImage={pod.showSecondaryImage}
          />
          <PodSection
            display="sui-block sui-w-full"
            padding="sui-px-1"
            noPadding
            columnAlign
            zIndex
            fitWidth
            aPointer
            pointerNone
            buttonPointer
          >
            <SuperSkuMiniSwatches
              itemId={pod.itemId}
              storeId={storeId}
              onChange={pod.onChange}
              onHover={pod.onSSKUHover}
            />
          </PodSection>
          <PodSection
            display="sui-grid"
            gap="sui-gap-2"
            padding="sui-mb-auto sui-px-1"
            alignTop
            noPadding
            columnAlign
          >
            <PodSpacer margin="md:sui-mt-1">
              <ProductHeader
                brand="above"
                itemId={pod.itemId}
                brandTitleMaxLine={4}
                onClick={onClick}
                disableShopThisCollection
              />
            </PodSpacer>
            <ProductRating itemId={pod.itemId} openDetailsInNewTab />
            <PodSpacer minHeight="60px">
              <Price
                itemId={pod.itemId}
                large={false}
                storeId={storeId}
                displayEachUom={false}
                onSavingsCenterToggle={pod.onSavingsCenterToggle}
                hideForProductTypes={['HDQC']}
              />
            </PodSpacer>
          </PodSection>
          <PodFooter>
            <PodSpacer padding={['TOP']}>
              <ProductATC
                itemId={pod.itemId}
                storeId={storeId}
                checkGeneric
                outline
              />
            </PodSpacer>
          </PodFooter>
        </>
      )}
    />
  );
};

IntegratedBrandBathPod.dataModel = extend(
  Favorite,
  ProductPod,
  Price,
  SuperSkuMiniSwatches,
  ProductATC,
  ProductRating,
  ProductImage,
  ProductHeader,
  ProductBadge,
  ProductSponsored
);

IntegratedBrandBathPod.propTypes = {
  itemId: string.isRequired,
  storeId: string.isRequired,
  parent: string.isRequired,
  position: number.isRequired,
  onClick: func,
};

IntegratedBrandBathPod.defaultProps = {
  onClick: () => {},
};

IntegratedBrandBathPod.displayName = 'IntegratedBrandPod';
